import { IconInfoCircle } from "@tabler/icons-react";
import { createFileRoute } from "@tanstack/react-router";
import i18next from "i18next";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import Button from "@/components/core/Buttons/Button";
import Checkbox from "@/components/core/Checkbox";
import { PopUp } from "@/components/core/Modals/PopUp";
import FmiWarningPopup from "@/components/DeviceReceipt/FmiWarningPopup";
import FactoryResetInstructions from "@/components/FactoryResetInstructions";
import { useDeviceVerification } from "@/hooks/useDeviceVerification";
import { useTagManager } from "@/hooks/useTagManager";
import { requireAuthWithDevice } from "@/lib/guards";
import { useStore } from "@/store";

export const Route = createFileRoute("/$locale/$partner/device-receipt-confirmation")({
	beforeLoad: requireAuthWithDevice,
	component: DeviceReceiptConfirmation,
});

function DeviceReceiptConfirmation() {
	const { t } = useTranslation();
	const category = useStore((state) => state.category);
	const [isFactoryResetChecked, setIsFactoryResetChecked] = useState(false);
	const [factoryResetStepsModal, setFactoryResetStepsModal] = useState(false);

	useTagManager("Device Receipt Confirmation");

	const { loading, error, fmiModal, setFmiModal, handleSubmit, verifyLockStatus } = useDeviceVerification();

	return (
		<>
			<div className="mx-auto max-w-[81rem]">
				<div className="mt-20 mb-32 flex items-center flex-col max-w-lg mx-auto">
					<h1 className="text-3xl font-semibold mb-12">{t("DeviceConfirmation.Device Receipt Confirmation")}</h1>
					<p>{t("DeviceConfirmation.Confirm below that the device is ready for trade-in")}</p>
					<div className="flex items-center w-full">
						<Checkbox
							selected={isFactoryResetChecked}
							onChange={(e) => setIsFactoryResetChecked(e.target.checked)}
							description={<p className="ml-6">{t("Checkboxes.Device Factory Reset")}</p>}
						/>
						{i18next.exists(`FactoryResetGuide.${category.charAt(0).toUpperCase() + category.slice(1)}`) && (
							<div
								className="mx-2 cursor-pointer"
								onClick={() => setFactoryResetStepsModal(true)}
							>
								<IconInfoCircle
									width={24}
									height={24}
									stroke={1}
									color="grey"
								/>
							</div>
						)}
					</div>
					<div className="w-fit mt-12 mx-auto">
						<Button
							label={t("Buttons.Verify")}
							loading={loading}
							disabled={!isFactoryResetChecked || loading}
							onClick={handleSubmit}
						/>
					</div>
					{error && <p className="text-center pt-6 text-red">{error}</p>}
				</div>
			</div>
			<PopUp
				className="px-12 py-12 max-w-3xl"
				isOpen={factoryResetStepsModal}
				setIsOpen={setFactoryResetStepsModal}
			>
				<FactoryResetInstructions category={category} />
			</PopUp>
			<FmiWarningPopup
				isOpen={fmiModal}
				setIsOpen={setFmiModal}
				loading={loading}
				onRetry={verifyLockStatus}
			/>
		</>
	);
}
